import { randomId } from '../utils/random-id/random-id.js';
function createAriaHider(containerNode) {
    var selector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "body > :not(script)";
    var id = randomId();
    var rootNodes = Array.from(document.querySelectorAll(selector)).map(function(node) {
        var _a;
        if (((_a = node == null ? void 0 : node.shadowRoot) == null ? void 0 : _a.contains(containerNode)) || node.contains(containerNode)) {
            return void 0;
        }
        var ariaHidden = node.getAttribute("aria-hidden");
        var prevAriaHidden = node.getAttribute("data-hidden");
        var prevFocusId = node.getAttribute("data-focus-id");
        node.setAttribute("data-focus-id", id);
        if (ariaHidden === null || ariaHidden === "false") {
            node.setAttribute("aria-hidden", "true");
        } else if (!prevAriaHidden && !prevFocusId) {
            node.setAttribute("data-hidden", ariaHidden);
        }
        return {
            node: node,
            ariaHidden: prevAriaHidden || null
        };
    });
    return function() {
        rootNodes.forEach(function(item) {
            if (!item || id !== item.node.getAttribute("data-focus-id")) {
                return;
            }
            if (item.ariaHidden === null) {
                item.node.removeAttribute("aria-hidden");
            } else {
                item.node.setAttribute("aria-hidden", item.ariaHidden);
            }
            item.node.removeAttribute("data-focus-id");
            item.node.removeAttribute("data-hidden");
        });
    };
}
export { createAriaHider }; //# sourceMappingURL=create-aria-hider.js.map
